export default __webpack_public_path__ + "static/media/icon-imprimante.ef85861f.svg";